import { create } from "zustand";

const DEFAULT_DATA = {
  mode: "html",
  theme: {
    label: "solarized_dark",
    value: "solarized_dark",
  },
  contentByMode: {},
};

export const useEasyHtmlStore = create((set, get) => ({
  data: DEFAULT_DATA,
  setData: (value) => set(() => ({ data: value })),
  getData: () => get().data,

  setMode: (mode) => set(() => ({ data: { ...get().data, mode } })),

  updateContentByMode: (mode, content) =>
    set(() => ({
      data: {
        ...get().data,
        contentByMode: { ...get().data.contentByMode, [mode]: content },
      },
    })),

  setTheme: (theme) => set(() => ({ data: { ...get().data, theme } })),

  resetStore: () => {
    set({
      data: DEFAULT_DATA,
    });
  },
}));
